import React from "react";

interface LoadingProps {
  size?: string;
  weight?: string;
  className?: string;
  color?: string;
}

const Loading: React.FC<LoadingProps> = ({ size, weight, className, color }) => {
  const loaderClass = className === "center-loader"
    ? "center-loader"
    : className
    ? className
    : "";

  return (
    <div className={loaderClass}>
      <div className="spinner-border text-primary" role="status"></div>

      <style jsx>{`
        .spinner-border {
          width: ${size ?? "2rem"} !important;
          height: ${size ?? "2rem"} !important;
          font-size: ${weight ?? "18px"} !important;
          color: ${color ?? "#0d6efd"} !important;
        }

        .center-loader {
          margin-top: 22% !important;
          margin-left: 50% !important;
        }
      `}</style>
    </div>
  );
};

export default Loading;
